/**
 * Main JavaScript file.
 */
/**
 * Component.
 */
import Navigation from './component/navigation.js';
import skipLinkFocus from './component/skip-link-focus-fix.js';
import './component/sticky-header';
import RisingBambooJsSearch from './component/search';
import RisingBambooOverlayScrollBar from './component/overlay-scroll-bar';
import SlickJs from './component/slick';
import SwiperJs from './component/swiper';
import RbbLightBox from './component/lightbox';

document.addEventListener( 'DOMContentLoaded', () => {
	const navigation = new Navigation();
	skipLinkFocus();
	navigation.setupNavigation();
	navigation.enableTouchFocus();
} );
const RisingBamboo = {
	config: {},

	adminBarHeight: 0,

	scrollPosition: 0,

	init() {
		const $this = this;
		$this.setConfig();
		$this.setScrollPosition();
		$this.setAdminBarHeight();
		$this.initStickyElements();
		$this.initScrollToTop();
		$this.searchActive();
		$this.footerElement();
		$this.toggleElement( '.toggle-megamenu', '.rbb-main-navigation ' );
		$this.menu_canvas();
		$this.delivery_banner();
		$this.title_typing();
		$this.parallax_background_banner(
			'.parallax_bg_banner .elementor-background-overlay'
		);
		new SlickJs( '.rbb-slick-el' );
		new SwiperJs( '.bc-swiper-el' );
		RisingBambooJsSearch.ajaxSearch();
		jQuery( window ).on( 'resize', function () {
			$this.onWindowResize();
		} );
		new RisingBambooOverlayScrollBar();
		new RbbLightBox( '#rbb-gallery-lightbox' );
		jQuery( window ).on( 'scroll', function () {
			$this.onWindowScroll();
		} );
		// $this.menu_one_page();
		$this.initFancyBox();
	},

	setConfig() {
		if ( typeof window.rbb_config === 'object' ) {
			this.config = window.rbb_config;
		}
	},

	setScrollPosition() {
		this.scrollPosition = jQuery( 'window' ).scrollTop();
	},

	setAdminBarHeight() {
		const adminBar = document.querySelector( '#wpadminbar' );

		if ( adminBar && window.outerWidth > 600 ) {
			this.adminBarHeight = adminBar.offsetHeight;
		}
	},

	initStickyElements() {
		jQuery( '.rbb-header-sticky' ).RbbStickyHeader(
			this.config.header_sticky
		);
	},

	initScrollToTop() {
		const $button = jQuery( '.scroll-to-top' );

		jQuery( window ).scroll( function () {
			const offset = jQuery( 'body' ).innerHeight() * 0.2;

			if ( jQuery( this ).scrollTop() > offset ) {
				$button.removeClass( 'opacity-0 pointer-events-none' );
			} else {
				$button.addClass( 'opacity-0 pointer-events-none' );
			}
		} );

		$button.on( 'click', function ( e ) {
			jQuery( 'body, html' ).animate(
				{
					scrollTop: 0,
				},
				400
			);

			e.preventDefault();
		} );
	},
	onWindowResize() {
		this.setAdminBarHeight();
	},

	onWindowScroll() {
		const isScrollUp = jQuery( window ).scrollTop() < this.scrollPosition;

		if ( isScrollUp ) {
			jQuery( window ).triggerHandler( 'scroll:up' );
		} else {
			jQuery( window ).triggerHandler( 'scroll:down' );
		}

		this.scrollPosition = jQuery( window ).scrollTop();
	},

	toggleElement( clickAble, content ) {
		jQuery( clickAble ).on( 'click', function () {
			if ( jQuery( content ).hasClass( 'active' ) ) {
				jQuery( content ).removeClass( 'active' );
				jQuery( 'body' ).removeClass( 'canvasmenu-right' );
			} else {
				jQuery( content ).addClass( 'active' );
				jQuery( 'body' ).addClass( 'canvasmenu-right' );
			}
		} );
		jQuery( content )
			.find( '.close' )
			.on( 'click', function () {
				if ( jQuery( content ).hasClass( 'active' ) ) {
					jQuery( content ).removeClass( 'active' );
					jQuery( 'body' ).removeClass( 'canvasmenu-right' );
				}
			} );
		jQuery( document ).mouseup( function ( e ) {
			if ( jQuery( e.target ).closest( content ).length === 0 ) {
				jQuery( content ).removeClass( 'active' );
				jQuery( 'body' ).removeClass( 'canvasmenu-right' );
			}
		} );
	},
	searchActive() {
		jQuery( '.rbb-search-categories .dropdown-item' ).click( function (
			e
		) {
			e.preventDefault();
			jQuery( '.rbb-search-categories .dropdown-item' ).removeClass(
				'active'
			);
			jQuery( this ).addClass( 'active' );
		} );
		jQuery( '.sidebar-overlay' ).on( 'click', function () {
			const $body = jQuery( 'body' );
			if ( $body.hasClass( 'active' ) ) {
				jQuery( '.rbb_results' ).removeClass( 'active' );
				$body.removeClass( 'active' );
			} else {
				jQuery( '.rbb_results' ).addClass( 'active' );
				$body.addClass( 'active' );
			}
		} );
	},
	footerElement() {
		if ( jQuery( window ).width() < 768 ) {
			const $footerTitle1 = jQuery(
				'.footer-title1 .elementor-heading-title'
			);
			$footerTitle1.click( function () {
				jQuery(
					'.footer-title1 .elementor-icon-list-items'
				).slideToggle( 'slow', function () {} );
				// eslint-disable-next-line no-unused-expressions
				$footerTitle1.hasClass( 'active' )
					? $footerTitle1.removeClass( 'active' )
					: $footerTitle1.addClass( 'active' );
			} );
			const $footerTitle2 = jQuery(
				'.footer-title2 .elementor-heading-title'
			);
			$footerTitle2.click( function () {
				jQuery(
					'.footer-title2 .elementor-icon-list-items'
				).slideToggle( 'slow', function () {} );
				// eslint-disable-next-line no-unused-expressions
				$footerTitle2.hasClass( 'active' )
					? $footerTitle2.removeClass( 'active' )
					: $footerTitle2.addClass( 'active' );
			} );
			const $footerTitle3 = jQuery(
				'.footer-title3 .elementor-heading-title'
			);
			$footerTitle3.click( function () {
				jQuery(
					'.footer-title3 .elementor-icon-list-items'
				).slideToggle( 'slow', function () {} );
				// eslint-disable-next-line no-unused-expressions
				$footerTitle3.hasClass( 'active' )
					? $footerTitle3.removeClass( 'active' )
					: $footerTitle3.addClass( 'active' );
			} );
		}
	},
	delivery_banner() {
		const $content1 = '.banner-content .hover_content1';
		const $content2 = '.banner-content .hover_content2';
		const $content3 = '.banner-content .hover_content3';
		const $content4 = '.banner-content .hover_content4';
		const $content5 = '.banner-content .hover_content5';
		jQuery( $content2 ).hover(
			function () {
				jQuery( $content1 ).addClass( 'active' );
			},
			function () {
				jQuery( $content1 ).removeClass( 'active' );
			}
		);
		jQuery( $content3 ).hover(
			function () {
				jQuery( $content1 ).addClass( 'active' );
				jQuery( $content2 ).addClass( 'active' );
			},
			function () {
				jQuery( $content1 ).removeClass( 'active' );
				jQuery( $content2 ).removeClass( 'active' );
			}
		);
		jQuery( $content4 ).hover(
			function () {
				jQuery( $content1 ).addClass( 'active' );
				jQuery( $content2 ).addClass( 'active' );
				jQuery( $content3 ).addClass( 'active' );
			},
			function () {
				jQuery( $content1 ).removeClass( 'active' );
				jQuery( $content2 ).removeClass( 'active' );
				jQuery( $content3 ).removeClass( 'active' );
			}
		);
		jQuery( $content5 ).hover(
			function () {
				jQuery( $content1 ).addClass( 'active' );
				jQuery( $content2 ).addClass( 'active' );
				jQuery( $content3 ).addClass( 'active' );
				jQuery( $content4 ).addClass( 'active' );
			},
			function () {
				jQuery( $content1 ).removeClass( 'active' );
				jQuery( $content2 ).removeClass( 'active' );
				jQuery( $content3 ).removeClass( 'active' );
				jQuery( $content4 ).removeClass( 'active' );
			}
		);
	},
	menu_canvas() {
		if ( jQuery( window ).width() < 1024 ) {
			jQuery( '.menu-container .hoverable' ).click( function () {
				if ( jQuery( this ).hasClass( 'menu-active' ) ) {
					jQuery( this ).removeClass( 'menu-active' );
					jQuery( this ).children( '.children' ).slideUp( 500 );
				} else {
					jQuery( this )
						.parent()
						.parent()
						.find( 'li' )
						.removeClass( 'menu-active' );
					jQuery( this )
						.parent()
						.parent()
						.find( 'li' )
						.children( '.children' )
						.slideUp( 500 );
					jQuery( this ).addClass( 'menu-active' );
					jQuery( this ).children( '.children' ).slideDown( 500 );
				}
			} );
		}
	},
	menu_one_page() {
		const $this = this;
		jQuery( '#menu-homepage-menu li.level-1 > a' ).on(
			'click',
			function ( event ) {
				event.preventDefault();
				const url = window.location.href;
				const link = jQuery( this ).attr( 'href' );
				if ( link.indexOf( '#' ) === 0 ) {
					$this.animateTo( link );
				} else if ( link.indexOf( '#' ) === -1 ) {
					if (
						link.replace( /^https?:\/\//, '' ) ===
						url.replace( /^https?:\/\//, '' )
					) {
						jQuery( 'html, body' ).animate(
							{ scrollTop: '0' },
							1000
						);
					} else {
						window.location.replace( link );
					}
				} else {
					try {
						const hash = new URL( link ).hash;
						if ( hash.length ) {
							$this.animateTo( hash );
						}
					} catch ( error ) {
						// eslint-disable-next-line no-console
						console.warn( 'This link is invalidate' );
					}
				}
			}
		);
	},
	animateTo( anchor ) {
		const element = jQuery( anchor );
		if ( element.length ) {
			jQuery( 'html, body' ).animate(
				{ scrollTop: element.offset().top },
				1000
			);
		}
	},
	initFancyBox() {
		jQuery( '.fancybox' ).fancybox( {} );
	},
	title_typing() {
		const $titleTyping = jQuery( '.title-tying' );
		let $time = 1000;
		const $timeSpan = 150;
		if ( $titleTyping ) {
			$titleTyping.find( 'span' ).each( function () {
				const $span = jQuery( this );
				const $textArr = $span.html().split( '' );
				$span.html( '' );
				setTimeout( function () {
					$textArr.forEach( ( letter, i ) =>
						setTimeout(
							() => $span.append( letter ),
							$timeSpan * i
						)
					);
				}, $time );
				$time += $textArr.length * $timeSpan;
			} );
		}
	},
	parallax_background_banner( parallaxBanner ) {
		jQuery( window ).scroll( function () {
			jQuery( parallaxBanner ).each( function () {
				const winHeight = jQuery( window ).height(),
					currentPosition = jQuery( window ).scrollTop(),
					offsetTop = jQuery( this ).offset().top,
					distanceY = offsetTop - winHeight,
					scrolled = ( currentPosition - distanceY ) * 0.045;
				jQuery( parallaxBanner ).css(
					'background-position',
					'top ' + scrolled + 'px right 0px'
				);
			} );
		} );
	},
};
window.RisingBamboo = RisingBamboo;
window.RisingBambooJsSearch = RisingBambooJsSearch;
jQuery( function () {
	RisingBamboo.init();
} );
